module.exports = __webpack_public_path__ + "img/MK.2ac054eb.svg";